export const MAIN_ROUTE = '/';
export const BUSKET_ROUTE = '/busket';
export const ITEM_ROUTE = '/kategory';
export const ITEM_SEARCH_ROUTE = '/itemSearch';
export const ITEM_MAIN_ROUTE = '/itemMain';
export const ITEM_KATEGOTY_ROUTE = '/itemKategory';
export const LOGIN_ROUTE = '/login';
export const ITEM_PREVIEW_ROUTE = '/itemPreview';
export const MY_ORDERS_ROUTE = '/my-orders';
export const NOT_FOUND_ROUTE = '/404';
export const RETURNS_ROUTE = '/returns';
export const PRIVACY_ROUTE = '/privacy';

/*admin*/
export const AMIN_MAIN_ROUTE = '/admin';
export const SLIDER_REDUCT_ROUTE = '/sliderReduct';
export const SLIDE_ADD_ROUTE = '/slideAdd';
export const KATEGORY_REDUCT_ROUTE = '/adminkategory';
export const CURRENT_KATEGORY_REDUCT_ROUTE = '/currentadminkategory';
export const CURRENT_POD_KATEGORY_REDUCT_ROUTE = '/currentadminpodkategory';
export const FILTER_REDUCT_ROUTE = '/adminfilter';
export const CURRENT_KATEGORY_FILTER_REDUCT_ROUTE = '/currentAdminFilterKategory';
export const CURRENT_POD_KATEGORY_FILTER_REDUCT_ROUTE = '/currentAdminFilterPodKategory';
export const ITEM_REDUCT_ROUTE = '/adminItem';
export const NEW_ITEM_POST_ROUTE = '/adminItemNewPost';
export const NEW_ITEM_REDUCT_ROUTE = '/adminItemReduct';
export const QWESTION_REDUCT_ROUTE = '/adminQwestionReduct';
export const REVIEW_REDUCT_ROUTE = '/adminReviewReduct';


